import React, { useState, useEffect } from "react";
import AOS from "aos";
import Menu from "../components/Menu";
import Footer from "../components/Footer";
import Preloader from "../components/sections/Preloader";
import ScrollTop from "../components/sections/ScrollTop";
import "../styles/wallet-checker.css";

const WalletChecker = () => {
  const [walletAddress, setWalletAddress] = useState("");
  const [checkResult, setCheckResult] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    AOS.init({
      duration: 2000,
      once: true,
    });
  }, []);

  const handleCheck = async () => {
    if (!walletAddress.trim()) {
      alert("Please enter a wallet address");
      return;
    }

    // Basic address validation
    if (!walletAddress.match(/^0x[a-fA-F0-9]{40}$/)) {
      alert("Invalid wallet address format");
      return;
    }

    setLoading(true);
    setCheckResult(null);

    try {
      const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:3001";
      const response = await fetch(`${API_BASE_URL}/api/wallet/check`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          address: walletAddress.trim(),
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || "Failed to check wallet");
      }

      setCheckResult({
        address: walletAddress.trim(),
        isWhitelisted: data.isWhitelisted,
        checkedAt: new Date().toLocaleString(),
      });
    } catch (error) {
      alert(error.message || "Failed to check wallet. Please try again.");
      console.error("Error checking wallet:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="wrapper">
      <Preloader />
      <Menu />

      <section
        className="wallet-checker"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/images/background/bg-banner.png)`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          backgroundAttachment: "fixed",
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="block-text center">
                <h6 className="sub-heading">
                  <span>Wallet Checker</span>
                </h6>
                <h3 className="heading" data-aos="fade-up">
                  Are you eligible for FREE MINT or NOT!
                </h3>
                <p className="mb-30">
                  Wallet Checker will go live one week before the mint, allowing
                  you to verify your status early. This tool helps you check
                  your eligibility and make sure you never miss your WL spots.
                  We wish everyone the best of luck securing their whitelist!
                </p>
              </div>

              <div className="checker-card">
                <h2>Enter Wallet Address</h2>
                <div className="input-group">
                  <input
                    type="text"
                    placeholder="0x..."
                    value={walletAddress}
                    onChange={(e) => setWalletAddress(e.target.value)}
                    className="wallet-input"
                  />
                  <button
                    onClick={handleCheck}
                    disabled={loading}
                    className="action-btn"
                  >
                    <span>{loading ? "Checking..." : "Check Wallet"}</span>
                  </button>
                </div>

                {checkResult && (
                  <div className="result-card">
                    <h3>Wallet Information</h3>
                    <div className="result-grid">
                      <div className="result-item">
                        <span className="result-label">Address:</span>
                        <span className="result-value">
                          {checkResult.address}
                        </span>
                      </div>
                      <div className="result-item">
                        <span className="result-label">Whitelist Status:</span>
                        <span
                          className={`result-value ${
                            checkResult.isWhitelisted ? "success" : "error"
                          }`}
                        >
                          {checkResult.isWhitelisted
                            ? "✓ Whitelisted"
                            : "✗ Not Whitelisted"}
                        </span>
                      </div>
                      {checkResult.checkedAt && (
                        <div className="result-item">
                          <span className="result-label">Checked At:</span>
                          <span className="result-value">
                            {checkResult.checkedAt}
                          </span>
                        </div>
                      )}
                    </div>
                    {checkResult.isWhitelisted ? (
                      <div className="whitelist-notification success-notification">
                        <h4>🎉 Congratulations!</h4>
                        <p>This wallet is whitelisted and eligible for FREE MINT.</p>
                      </div>
                    ) : (
                      <div className="whitelist-notification error-notification">
                        <h4>⚠️ Not Whitelisted</h4>
                        <p>This wallet is not in the whitelist. Please check again later or contact support.</p>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
      <ScrollTop />
    </div>
  );
};

export default WalletChecker;
